import type { IconProps } from '../../internal/components/icons/types';

export const IconSolidMetrics = ({ size = '1em', ...props }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 20 20"
    focusable="false"
    {...props}
  >
    <path
      d="M9.97571 5.41622C6.82771 5.41622 4.31717 7.9012 4.31717 10.9162C4.31717 12.5499 5.04907 14.0212 6.22415 15.0337C6.71326 15.4551 6.76695 16.1918 6.34406 16.6793C5.92117 17.1667 5.18185 17.2202 4.69274 16.7987C3.03224 15.3681 1.97571 13.2648 1.97571 10.9162C1.97571 6.56745 5.58031 3.08289 9.97571 3.08289C10.3614 3.08289 10.7415 3.10969 11.1138 3.16172C11.7541 3.2511 12.2004 3.84087 12.1107 4.47898C12.021 5.11708 11.4292 5.56187 10.7889 5.47243C10.5239 5.43544 10.2524 5.41622 9.97571 5.41622Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    />
    <path
      d="M16.5433 8.74081C17.182 8.6407 17.7812 9.0756 17.8816 9.71213C17.9436 10.1053 17.9757 10.5075 17.9757 10.9162C17.9757 13.2648 16.9192 15.3681 15.2587 16.7987C14.7696 17.2202 14.0302 17.1667 13.6074 16.6793C13.1845 16.1918 13.2382 15.4551 13.7273 15.0337C14.9023 14.0212 15.6342 12.5499 15.6342 10.9162C15.6342 10.6293 15.6117 10.3482 15.5686 10.0744C15.4682 9.43798 15.9046 8.84087 16.5433 8.74081Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    />
    <path
      d="M14.4775 4.83705C14.9447 4.37147 15.7022 4.37147 16.1694 4.83705C16.6366 5.30264 16.6366 6.05753 16.1694 6.52312L12.7775 9.9032C12.8998 10.2285 12.9666 10.5808 12.9666 10.9486C12.9666 12.5947 11.6275 13.9292 9.97571 13.9292C8.32387 13.9292 6.98479 12.5947 6.98479 10.9486C6.98479 9.30251 8.32387 7.96809 9.97571 7.96809C10.378 7.96809 10.7617 8.04722 11.1121 8.19076L14.4775 4.83705Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);
